import React, { useCallback, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoChevronBack } from 'react-icons/io5';
import { BiLink } from 'react-icons/bi';

import { getTherapeuticAreaAction } from '../../actions/contentActions';
import styles from './TherapeuticAreaView.module.scss';

export default function TherapeuticAreaView() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const therapeuticArea = useSelector((state) => state.content.therapeuticArea);

  const load = useCallback(() => {
    if (id) getTherapeuticAreaAction(dispatch, id);
  }, [dispatch, id]);

  useEffect(() => {
    load();
  }, [load]);

  const clinoctaBase = process.env.REACT_APP_CLINOCTA_URL;

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.title}>
          <h2>
            {therapeuticArea?.name
              ? `AIRES THÉRAPEUTIQUES / ${therapeuticArea.name}`
              : 'AIRE THÉRAPEUTIQUE'}
          </h2>
          <Link to="/majee/aires" className={styles.back}>
            <IoChevronBack size={20} />
            retour à la liste
          </Link>
        </div>
      </header>

      {therapeuticArea?._id && (
        <main className={styles.content}>
          <div className={styles.col}>
            <section>
              <h3>Information</h3>
              <div className={styles['input-list']}>
                <div className={styles.block}>
                  <label>Nom</label>
                  <div className={styles.value}>
                    {therapeuticArea?.name ? (
                      <p className={styles.bold}>{therapeuticArea.name}</p>
                    ) : (
                      <span>non complété</span>
                    )}
                  </div>
                </div>
                <div className={styles.block}>
                  <label>Description</label>
                  <div className={styles.value}>
                    {therapeuticArea?.description ? (
                      <p className={styles.bold}>{therapeuticArea.description}</p>
                    ) : (
                      <span>non complété</span>
                    )}
                  </div>
                </div>
              </div>
            </section>

            {therapeuticArea?.studies?.length > 0 && (
              <section className={styles.border}>
                <label>Études cliniques</label>
                <div className={`${styles.list} ${styles.links}`}>
                  {therapeuticArea.studies.map((p) => {
                    if (clinoctaBase) {
                      return (
                        <a
                          key={p._id}
                          href={`${clinoctaBase}/edit-study/${p._id}`}
                          target="_blank"
                          rel="noreferrer"
                          className={styles.link}
                        >
                          <span>{p.name}</span>
                          <BiLink size={18} />
                        </a>
                      );
                    }
                    return (
                      <span key={p._id} className={styles.item}>{p.name}</span>
                    );
                  })}
                </div>
              </section>
            )}

            {therapeuticArea?.drugs?.length > 0 && (
              <section className={styles.border}>
                <label>Produits</label>
                <div className={`${styles.list} ${styles.links}`}>
                  {therapeuticArea.drugs.map((d) => (
                    <Link
                      key={d._id}
                      to={`/majee/produits/${d._id}`}
                      className={styles.link}
                    >
                      <span>{d.name}</span>
                      <BiLink size={18} />
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </div>
        </main>
      )}
    </div>
  );
}
